#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

mutation EntityDocumentEmailCreate($input: EntityDocumentEmailCreateInput!) {
  entityDocumentEmailCreate(input: $input) {
    purchaseOrderEmail {
      __typename
      id
      _emailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
